// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2vTk0","header":"Messages_header__15lJC"};